import React, { useState } from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { menuItems } from "../../constant/ManuItem";
import { useDispatch, useSelector } from "react-redux";
import useWindowWidth from "../../../../Hooks/useWindow";
import { uiAction } from "../../../../Redux/Slices/uiSlice";
const NavMenu = () => {
    const width = useWindowWidth();
    const [openDropdown, setOpenDropdown] = useState(null);
    const showSideBar = useSelector(state => state.uiReducers?.sideBarToggle)
    const dispatch = useDispatch();
    const handleCloseSidebar = (index) => {
        dispatch(uiAction.setSideBarToggle())
    }
    return (
        <ul className={`navbar-nav navbar-nav-top ${width > 990 ? "" : showSideBar ? "show" : "hide"}`}>
            {menuItems.map((item, idx) => {
                const isOpen = openDropdown === idx;
                const hasDropdown = item.subItems && item.subItems.length > 0;
                return (
                    <li
                        key={idx}
                        className={classNames("nav-item", { dropdown: hasDropdown, show: isOpen })}
                        onMouseEnter={() => hasDropdown && setOpenDropdown(idx)}
                        onClick={() => hasDropdown && setOpenDropdown(idx)}
                        onMouseLeave={() => hasDropdown && setOpenDropdown(null)}
                    >
                        <Link
                            className={classNames("nav-link", "lh-1", {
                                "dropdown-toggle": hasDropdown,
                            })}
                            to={item.href || "#"}
                            role="button"
                            aria-haspopup="true"
                            aria-expanded={isOpen}
                        // onClick={handleCloseSidebar}
                        >
                            <span className="uil fs-8 me-2">
                                {item.isSvg ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={item.icon}>
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                        <circle cx="9" cy="7" r="4" />
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                    </svg>
                                ) : (
                                    <span className={item.icon} />
                                )}
                            </span>
                            {item.label}
                        </Link>
                        {hasDropdown && (
                            <ul
                                // navbar-dropdown-caret
                                className={classNames("dropdown-menu navbar-dropdown-caret  ", {
                                    show: isOpen,
                                })}
                                style={(width > 990) ? {} : { background: "#7a3a00" }}
                            >
                                {item.subItems.map((sub, subIdx) => (
                                    <li key={subIdx}>
                                        <Link onClick={handleCloseSidebar} target={sub.label === "The River Castle" || sub.label === "Dholera" ? "_blank" : "_self"} className="dropdown-item" to={sub.link || "#"}>
                                            <div>
                                                <span>
                                                    <span className={classNames("me-2", sub.icon)}></span>
                                                    {sub.label}
                                                </span>
                                            </div>
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </li>
                );
            })}
        </ul>
    );
};

export default NavMenu;